import React from "react";
import { connect } from "react-redux";
import Card from "components/card";

const Pipeline = ({ steps = [] }) => {
    if (!steps.length) return null;

    return (
        <Card className="flex flex-col gap-6 rounded-2xl bg-white shadow-lg border-2 border-slate-200 overflow-hidden">
            <div className="bg-gradient-to-br from-slate-50 to-cyan-50 border-b rounded-t-2xl p-5 grid gap-2">
                <h4 className="text-[18px]">
                    Hiring Pipeline Overview
                </h4>
                <p className="text-[14px] text-slate-700">
                    Visual representation of candidate journey
                </p>
            </div>

            <div className="pb-6 p-6">
                <div className="space-y-6"> 
                    <div className="hidden lg:block px-4">
                        <div className="relative flex justify-between items-center w-full mx-auto gap-1">
                            {steps.map((step, index) => (
                                <div key={index} className="relative flex flex-col items-center w-full">
                                    {index !== steps.length - 1 && (
                                        <div className="absolute top-7 left-1/2 w-full h-[2px] bg-gradient-to-r from-slate-300 to-slate-200 z-0"></div>
                                    )}
                                    <div className={`relative z-10 w-14 h-14 rounded-xl flex items-center justify-center mb-3 pipeline-steps ${step.name.toLowerCase().replace(/\s+/g, '-') } shadow-lg`}>
                                        <step.icon className="text-white w-6 h-6" />
                                        {step.count > 0 && (
                                            <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-red-500 text-white flex items-center justify-center text-[10px] font-semibold border-2 border-white shadow-md">
                                                {step.count}
                                            </div>
                                        )}
                                    </div>
                                    <span className="text-[12px] text-center max-w-[70px] leading-tight min-h-[28px] flex items-center justify-center">
                                        {step.name}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div role="separator" className="w-full h-[1px] bg-slate-300"></div>
                    <div className="w:px-6">
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-9 gap-2">
                            {steps.map((step, index) => (
                                <div
                                    key={index}
                                    className="p-3 rounded-lg bg-slate-50 border border-slate-200 text-center hover:border-slate-300 hover:shadow-sm transition-all flex flex-col items-center justify-center"
                                >
                                    <p className="text-[22px] font-semibold text-slate-900 mb-1">
                                        {step.count}
                                    </p>
                                    <p className="text-[9px] text-muted-foreground uppercase tracking-wide leading-tight">
                                        {step.name}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

const mapStateToProps = () => ({

});
const mapDispatchToProps = () => ({
    
});

export default connect(mapStateToProps, mapDispatchToProps)(Pipeline);
